export const WITH_LOADING = 'withLoading'
export default {
  WITH_LOADING
}
